import { createApi } from '@reduxjs/toolkit/query/react';
import { createAuthBaseQuery } from './baseQuery';

export const dashboardApi = createApi({
  reducerPath: 'dashboardApi',
  baseQuery: createAuthBaseQuery(),
  tagTypes: ['Dashboard'],
  endpoints: (builder) => ({
    getDashboardStats: builder.query<Record<string, unknown>, void>({
      query: () => 'dashboard/stats',
      providesTags: ['Dashboard'],
    }),
    getRecentOrders: builder.query<unknown[], void>({
      query: () => 'dashboard/recent-orders',
      providesTags: ['Dashboard'],
    }),
    getProductionDetails: builder.query<Record<string, unknown>, void>({
      query: () => 'dashboard/production-details',
      providesTags: ['Dashboard'],
    }),
  }),
});

export const {
  useGetDashboardStatsQuery,
  useGetRecentOrdersQuery,
  useGetProductionDetailsQuery,
} = dashboardApi;
